// eslint-disable
// oxlint-disable

'use strict';

import { Iterable } from '@gonfalon/immutable-shim/immutableShim';

var isMap = function (obj) {
  return Iterable.isKeyed(obj);
};
var isIndexed = function (obj) {
  return Iterable.isIndexed(obj);
};

var op = function (operation, path, value) {
  if (operation === 'remove') {
    return { op: operation, path: path };
  }

  return { op: operation, path: path, value: value };
};

export default {
  isMap: isMap,
  isIndexed: isIndexed,
  op: op,
};
